import { render, staticRenderFns } from "./file-display.vue?vue&type=template&id=7b7a0876&scoped=true"
import script from "./file-display.vue?vue&type=script&lang=js"
export * from "./file-display.vue?vue&type=script&lang=js"
import style0 from "./file-display.vue?vue&type=style&index=0&id=7b7a0876&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7a0876",
  null
  
)

export default component.exports